/** Steps項目 */
export const A200_STEPS_ITEMS = [
  { label: '入会申請' },
  { label: '確認' },
  { label: 'メールアドレス確認' },
  { label: '入会申請完了' },
];
